import { type ReactElement, type ReactNode } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Alert } from '@mantine/core'
import { usePermissionCheck, useProfile } from '@front/model'
import { NotReady, Page, WebGlGuard } from '@components'
import { BatchGeocoder } from './BatchGeocoder'

function BatchGeocoderRoute(): ReactNode {
  const { company, isLoading: isLoadingProfile } = useProfile()
  const { data: hasPermission, isLoading: isLoadingPermission } = usePermissionCheck({
    permissionType: 'location:manage',
    targetId: company?.companyId,
  })

  if (isLoadingProfile || isLoadingPermission || !company) return <NotReady isLoading />
  if (!hasPermission) return <BatchGeocoderAccessDenied />

  return (
    <WebGlGuard>
      <BatchGeocoder />
    </WebGlGuard>
  )
}

function BatchGeocoderAccessDenied(): ReactElement {
  return (
    <Page>
      <Page.Heading title='Batch Geocoder' />
      <Page.Content>
        <Alert color='red' title='Access Denied'>
          You do not have permission to use the batch geocoder.
        </Alert>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/location/geocode/')({
  component: BatchGeocoderRoute,
})
